import { startEditingAction } from '../designerReducer';
import { getDefaultBlogDesign } from '@/configs/defaultBlogDesign';

export const startNewDesign = (name, mode = 'light') => dispatch => {
  dispatch(startEditingAction({ ...getDefaultBlogDesign(mode), name }));
};
